// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"aee005a1","409":"1d2eb829","689":"2d0d880a","849":"4784e0a7"}[chunkId] + ".chunk.js";
};